export default abstract class Translation {
    format(value: string, ...params: string[]): string {
        params.forEach(param => value = value.replace("%%%", param));
        return value;
    }

    readonly languageKey: string = "";
    readonly languageFlag: string = "";
    readonly 401: string = "";
    readonly 404: string = "";
    readonly 409: string = "";
    readonly 422: string = "";
    readonly 500: string = "";
    readonly all: string = "";
    readonly admin: string = "";
    readonly loginFormMailPh: string = "";
    readonly loginFormPwdPh: string = "";
    readonly loginFormError: string = "";
    readonly vegetableTypeSelect: string = "";
    readonly nut: string = "";
    readonly flower: string = "";
    readonly cereal: string = "";
    readonly fruit: string = "";
    readonly navbarBtnEdit: string = "";
    readonly homeMessageAdmin: string = "";
    readonly homeMessageSupplier: string = "";
    readonly homeMessageCustomer: string = "";
    readonly addBillModalBillNb: string = "";
    readonly addBillModalHelp: string = "";
    readonly selected: string = "";
    readonly see: string = "";
    readonly videos: string = "";
    readonly edit: string = "";
    readonly save: string = "";
    readonly cancel: string = "";
    readonly android: string = "";
    readonly iOS: string = "";
    readonly web: string = "";
    readonly information: string = "";
    readonly type: string = "";
    readonly bill: string = "";
    readonly bills: string = "";
    readonly customer: string = "";
    readonly clients: string = "";
    readonly categories: string = "";
    readonly allCategories: string = "";
    readonly newCategory: string = "";
    readonly catalogs: string = "";
    readonly allCatalogs: string = "";
    readonly newCatalog: string = "";
    readonly usersAndAccess: string = "";
    readonly settings: string = "";
    readonly supplier: string = "";
    readonly suppliers: string = "";
    readonly group: string = "";
    readonly member: string = "";
    readonly number: string = "";
    readonly status: string = "";
    readonly delete: string = "";
    readonly position: string = "";
    readonly positionHint: string = "";
    readonly action: string = "";
    readonly modelName: string = "";
    readonly fileName: string = "";
    readonly weight: string = "";
    readonly download: string = "";
    readonly upload: string = "";
    readonly creationDate: string = "";
    readonly headerLogout: string = "";
    readonly headerLogoutConfirm: string = "";
    readonly headerTitle: string = "";
    readonly headerNoData: string = "";
    readonly modalPositiveBtn: string = "";
    readonly modalNegativeBtn: string = "";
    readonly addUserModalDuplicate: string = "";
    readonly addUserModalMail: string = "";
    readonly addUserModalFirstName: string = "";
    readonly addUserModalLastName: string = "";
    readonly UserComponentResetPassword: string = "";
    readonly UserComponentResetPasswordConfirm: string = "";
    readonly UserComponentRemoveUser: string = "";
    readonly UserComponentRemoveUserConfirm: string = "";
    readonly UserComponentTitle: string = "";
    readonly UserComponentAddUserBtn: string = "";
    readonly groupComponentMemberListTab: string = "";
    readonly loading: string = "";
    readonly identifier: string = "";
    readonly clientListColID: string = "";
    readonly categoryListColID: string = "";
    readonly categoryListColTitle: string = "";
    readonly categoryListEmpty: string = "";
    readonly categoryId: string = "";
    readonly catalogId: string = "";
    readonly catalogListColID: string = "";
    readonly catalogListColTitle: string = "";
    readonly catalogListEmpty: string = "";
    readonly catalogAvailability: string = "";
    readonly assignedCatalog: string = "";
    readonly profiles: string = "";
    readonly newProfile: string = "";
    readonly emptyUuidListAddProfile: string = "";
    readonly emptyCatalogListAddProfile: string = "";
    readonly emptyVideoList: string = "";
    readonly profileEdited: string = "";
    readonly profileCreated: string = "";
    readonly profileName: string = "";
    readonly profileId: string = "";
    readonly profileListColID: string = "";
    readonly profileListColName: string = "";
    readonly profileListEmpty: string = "";
    readonly clientListColName: string = "";
    readonly clientListColEnabled: string = "";
    readonly clientListColScope: string = "";
    readonly clientListEmpty: string = "";
    readonly userListColID: string = "";
    readonly userListColRole: string = "";
    readonly userListColFirstName: string = "";
    readonly userListColLastName: string = "";
    readonly userListColLastPwd: string = "";
    readonly userListColPhone: string = "";
    readonly userListColAction: string = "";
    readonly userListEmpty: string = "";
    readonly userListResetPwdBtn: string = "";
    readonly userListRemoveUserFromGrpBtn: string = "";
    readonly userListClientsIds: string = "";
    readonly searchTitle: string = "";
    readonly searchByNamePH: string = "";
    readonly searchBtn: string = "";
    readonly searchFilterTitle: string = "";
    readonly searchClearBtn: string = "";
    readonly modelDescriptionCancelConfirm: string = "";
    readonly settingsPwdReset: string = "";
    readonly settingsResetPasswordConfirm: string = "";
    readonly alertOk: string = "";
    readonly alertCancel: string = "";
    readonly switchLanguage: string = "";
    readonly formInvalidField: string = "";
    readonly formPasswordInvalid: string = "";
    readonly userAdded: string = "";
    readonly userEdited: string = "";
    readonly categoryAdded: string = "";
    readonly categoryEdited: string = "";
    readonly catalogAdded: string = "";
    readonly catalogEdited: string = "";
    readonly clientAdded: string = "";
    readonly clientEdited: string = "";
    readonly password: string = "";
    readonly client_credentials: string = "";
    readonly refresh_token: string = "";
    readonly grantTypes: string = "";
    readonly openRegistration: string = "";
    readonly openRegistrationShort: string = "";
    readonly redirectUri: string = "";
    readonly details: string = "";
    readonly list: string = "";
    readonly allClients: string = "";
    readonly allUsers: string = "";
    readonly expired: string = "";
    readonly valid: string = "";
    readonly token: string = "";
    readonly tokenListEmpty: string = "";
    readonly tokenListAccessToken: string = "";
    readonly tokenListRefreshToken: string = "";
    readonly tokenListCreatedAt: string = "";
    readonly tokenListExpiresIn: string = "";
    readonly pageTotal: string = "";
    readonly identity: string = "";
    readonly oldPassword: string = "";
    readonly newPassword: string = "";
    readonly saved: string = "";
    readonly revoke: string = "";
    readonly revoked: string = "";
    readonly accessTokenCopied: string = "";
    readonly refreshTokenCopied: string = "";
    readonly accountStatus: string = "";
    readonly roles: string = "";
    readonly ADMIN: string = "";
    readonly CUSTOMER: string = "";
    readonly STANDARD: string = "";
    readonly manager: string = "";
    readonly library: string = "";
    readonly newUser: string = "";
    readonly newClient: string = "";
    readonly userMenu: string = "";
    readonly pages: string = "";
    readonly devices: string = "";
    readonly device: string = "";
    readonly uuid: string = "";
    readonly clientId: string = "";
    readonly clientSecret: string = "";
    readonly deviceListEmpty: string = "";
    readonly copied: string = "";
    readonly enabled: string = "";
    readonly newDevice: string = "";
    readonly deviceCreated: string = "";
    readonly deviceRemoveConfirmation: string = "";
    readonly videoRemoveConfirmation: string = "";
    readonly formPhoneInvalid: string = "";
    readonly id: string = "";
    readonly title: string = "";
    readonly subtitle: string = "";
    readonly description: string = "";
    readonly duration: string = "";
    readonly published: string = "";
    readonly videoList: string = "";
    readonly videoListEmpty: string = "";
    readonly newVideo: string = "";
    readonly videoCreated: string = "";
    readonly videoUpdated: string = "";
    readonly videoSettings: string = "";
    readonly video360: string = "";
    readonly video720: string = "";
    readonly thumbnail: string = "";
    readonly deleteVideo: string = "";
    readonly deleteVideoButton: string = "";
    //PH
}